import { FC } from "react";
import { Chip } from "@mui/material";

import { EDI_CHIP_STYLES } from "./ediCardStyles";
import { EdiCardChipInfo } from "./ediObjectHelpers";

const CardChip: FC<{ chip: EdiCardChipInfo }> = ({ chip }) => (
  <Chip
    label={chip.label}
    size="small"
    sx={{
      height: 20,
      borderRadius: "999px",
      backgroundColor: EDI_CHIP_STYLES[chip.kind].bg,
      "& .MuiChip-label": {
        color: EDI_CHIP_STYLES[chip.kind].color,
        fontSize: "0.7rem",
        fontWeight: 600,
        px: 1,
      },
    }}
  />
);

export default CardChip;
